import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import "@/App.css";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";

// Route-level code splitting: public visitors only download the page they visit.
// The heavy Admin Dashboard (charts + image cropper) never loads for the public.
// If a lazy chunk 404s because an open tab still holds a pre-deploy bundle,
// hard-reload once (max once per 30s) to fetch the fresh build instead of
// leaving the visitor stuck on the old screen or a blank page.
const CHUNK_RELOAD_KEY = "chunk-reload-at";
const lazyWithRetry = (factory) => lazy(async () => {
  try {
    return await factory();
  } catch (err) {
    const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
    if (Date.now() - last > 30000) {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
      window.location.reload();
      return new Promise(() => {}); // suspend until the reload happens
    }
    throw err;
  }
});

const About = lazyWithRetry(() => import("@/pages/About"));
const Products = lazyWithRetry(() => import("@/pages/Products"));
const Services = lazyWithRetry(() => import("@/pages/Services"));
const Solutions = lazyWithRetry(() => import("@/pages/Solutions"));
const ServiceDetail = lazyWithRetry(() => import("@/pages/ServiceDetail"));
const ProductZoho = lazyWithRetry(() => import("@/pages/ProductZoho"));
const ProductAbsolute = lazyWithRetry(() => import("@/pages/ProductAbsolute"));
const ZohoSolution = lazyWithRetry(() => import("@/pages/ZohoSolution"));
const AbsoluteSolution = lazyWithRetry(() => import("@/pages/AbsoluteSolution"));
const Contact = lazyWithRetry(() => import("@/pages/Contact"));
const Legal = lazyWithRetry(() => import("@/pages/Legal"));
const Blog = lazyWithRetry(() => import("@/pages/Blog"));
const BlogPost = lazyWithRetry(() => import("@/pages/BlogPost"));
const Events = lazyWithRetry(() => import("@/pages/Events"));
const ResourceLibrary = lazyWithRetry(() => import("@/pages/ResourceLibrary"));
const GeoLanding = lazyWithRetry(() => import("@/pages/GeoLanding"));
const Advisory = lazyWithRetry(() => import("@/pages/Advisory"));
const HostingerOffer = lazyWithRetry(() => import("@/pages/HostingerOffer"));
const AdminLogin = lazyWithRetry(() => import("@/pages/admin/AdminLogin"));
const AdminDashboard = lazyWithRetry(() => import("@/pages/admin/AdminDashboard"));

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/zoho" element={<ProductZoho />} />
            <Route path="/products/zoho/:slug" element={<ZohoSolution />} />
            <Route path="/products/absolute" element={<ProductAbsolute />} />
            <Route path="/products/absolute/:slug" element={<AbsoluteSolution />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal/:slug" element={<Legal />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/events" element={<Events />} />
            <Route path="/resources" element={<ResourceLibrary />} />
            <Route path="/software-development-company/:city" element={<GeoLanding />} />
            <Route path="/hostinger-offer" element={<HostingerOffer />} />
            <Route path="/php2shell-security-advisory" element={<Advisory />} />
            <Route path="/security-advisory" element={<Advisory />} />
          </Route>
          <Route path="/admin" element={<Suspense fallback={<div className="min-h-screen" />}><AdminLogin /></Suspense>} />
          <Route path="/admin/dashboard" element={<Suspense fallback={<div className="min-h-screen" />}><ProtectedRoute><AdminDashboard /></ProtectedRoute></Suspense>} />
        </Routes>
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
